import React from 'react';
import Modal from 'react-modal';
import { Styles } from 'react-modal';

const customStyles: Styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.50)',
        zIndex: 1000
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: "400px",
        width: "100%",
        padding: "50px",
        fontSize: "16px",
        textAlign: "center"
    },
};


interface ITimeoutWarningModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    onLogin: () => void;
    ariaHideApp: boolean;
}


const TimeoutWarningModal: React.FC<ITimeoutWarningModalProps> = ({ isOpen, onRequestClose, onLogin, ariaHideApp }) => {
    return (
        <Modal isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={customStyles}
            contentLabel="Session Expired"
            ariaHideApp={ariaHideApp}
        >
            <h2 className="css_heading bold">Session Expired</h2>
            <div>You have been logged out.</div>
            <br />
            <div>
                <button className="solidNeg primaryButton" style={{ margin: 5 }} onClick={onRequestClose}>Continue</button>
                <button className="solidNeg primaryButton" style={{ margin: 5 }} onClick={onLogin}>Log In</button>                       
            </div>
        </Modal>
    );
};

export default TimeoutWarningModal;